import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { ReportsService } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../modules/authentication/services/auth.service';

@Component({
  selector: 'switch-company-via-report',
  template: `
    <span>
      <span *ngIf="benchmarkValue; else renderLinkButton">{{ benchmarkValue }}</span>

      <ng-template #renderLinkButton>
        <button mat-button fxFlex class="grid-link-button grid-text" (click)="triggerLinkButtonAction()">
          {{ value }}
        </button>
      </ng-template>
    </span>
  `,
  styles: [],
})
export class SwitchCompanyLinkButtonComponent implements ICellRendererAngularComp {
  public value: string;
  public benchmarkValue: string;

  constructor(private rptService: ReportsService, private cService: CommonService, private authService: AuthService) {}

  agInit(params: { value: any }) {
    if (params.value && typeof params.value === 'string' && params.value.toLowerCase() === 'benchmark') {
      this.benchmarkValue = this.cService.readyTranslations.reportData.benchmark;
    } else {
      this.value = params.value;
    }
  }

  triggerLinkButtonAction() {
    setTimeout(() => {
      const selectedDistributor = this.rptService.selectedRows[0].dsp;
      this.authService.switchToSelectedCompany(selectedDistributor);
    }, 150);
  }

  refresh() {
    return false;
  }
}
